export default __webpack_public_path__ + "static/media/36I-102699_-15671_0.a55e63ae.jpg";